<template>
  <el-container class="app-wrapper">
    <el-main class="main-container">
      <div class="content-view">
        <router-view />
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Geo'
}
</script>

<style scoped>
/* 1. 整体容器铺满全屏 */
.app-wrapper {
  height: 100vh;
  width: 100vw;
  background-color: #f4f5f7;
}

/* 2. 核心：主区域铺满 */
.main-container {
  padding: 0 !important; /* 覆盖 el-main 默认内边距 */
  overflow: hidden;
}

.content-view {
  width: 100%;
  height: 100%;
}
</style>

<style>
/* 全局样式覆盖：去掉 body 默认边距 */
body {
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>
